import { render } from "./Q10-ChooseMood.vue?vue&type=template&id=0090c695&scoped=true"
import script from "./Q10-ChooseMood.vue?vue&type=script&lang=js"
export * from "./Q10-ChooseMood.vue?vue&type=script&lang=js"

import "./Q10-ChooseMood.vue?vue&type=style&index=0&id=0090c695&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0090c695"]])

export default __exports__